export * from './logo';

//# sourceMappingURL=index.js.map